import axios from 'axios';
import { Api } from './Api';

/*자동문자 설정 가져오는 api */
export const getAutoMessageSetting = async (data) => {
    const response = await axios.get(
        `${Api.ServerJSON.getInstance().BROJ_SERVER}api/jgroup/${
            data.jgroup_key
        }/auto-message`,
    );
    return response.data.result;
};
//대여권 최초 구매시
//대여권 재구매 시
//쿠폰 만료
//홀딩 종료 임박
//수강권 만료전
/* 자동문자 인증된 번호 가져오는 api*/
export const getCertificateData = async (data) => {
    const response = await axios.get(
        `${
            Api.ServerJSON.getInstance().BROJ_SMS_NANO_SERVER
        }massage/certificate?jgroup_key=${data.jgroup_key}`,
    );
    return response.data.data;
};

export const getCertificateToKTMessageServer = async (data) => {
    const response = await axios.get(
        `${
            Api.ServerJSON.getInstance().BROJ_MESSAGE_API_SERVER
        }/v1/admin/groups/${data.jgroup_key}/certificates`,
    );
    return response.data.result;
};

export const getGroupSegments = async (data) => {
    const response = await axios.get(
        `${Api.ServerJSON.getInstance().BROJ_SERVER}v1/admin/groups/${
            data.group_key
        }/list-types/${
            data.list_type || 'CUSTOMER'
        }/segments`,
    );

    return response.data.result;
};

export const getCustomerCountBySegment = async (data) => {
    const response = await axios.post(
        `${Api.ServerJSON.getInstance().BROJ_SERVER}v1/admin/groups/${
            data.group_key
        }/customers/count`,
        { segment_key: data.segment_key },
    );

    return response.data.result;
};

/** 메시지 내역을 가져오는 함수
 * @param data moment(date)
 */
// 메세지 내역 (구) - nano 서버로만 검색한다.
export const getMessageHistory = async (data) => {
    let sms = [];
    let lms = [];
    try {
        let response = await axios.get(
            `${
                Api.ServerJSON.getInstance().BROJ_SMS_NANO_SERVER
            }massage/sms?sendDate=${data.date}&TR_ETC1=${data.jgroup_key}`,
        );
        if (response.data.data) {
            sms = [...sms, ...response.data.data];
        }

        /** mms API를 요청하는 양식이지만, 아직 mms쪽 서버 개발이 안된 상태이며, lms 데이터를 넘기는 형태로 되어있습니다.
         * 따라서, 나중에 mms가 만들어지면 그때 이걸 그대로 사용하면 됩니다.
         */
        response = await axios.get(
            `${
                Api.ServerJSON.getInstance().BROJ_SMS_NANO_SERVER
            }massage/mms?sendDate=${data.date}&ETC1=${data.jgroup_key}`,
        );
        if (response.data.data) {
            lms = [...lms, ...response.data.data];
        }
        return { sms, lms };
    } catch (e) {
        console.log(e);
    }
};
/** 메세지 내역(신)을 가져오는 함수
 * type : send_history(발송 내역) / reserved_history(예약 내역)
 * {
 *  page
 *  size
 *  search_start_time
 *  search_end_time
 *  keyword
 *  group_key
 *  job_type (null(전체), SMS, LMS, MMS)
 * }
 */
export const getMonoMessageHistory = async (data, type) => {
    const sendType = type || 'send_history';
    try {
        // kt - 발송 내역
        if (sendType === 'send_history') {
            const response = await axios.get(
                `${
                    Api.ServerJSON.getInstance().BROJ_MESSAGE_API_SERVER
                }/v1/admin/mono-sms`,
                {
                    params: data,
                },
            );

            return response.data.result;
        }
        // kt - 예약 내역
        const response = await axios.get(
            `${
                Api.ServerJSON.getInstance().BROJ_MESSAGE_API_SERVER
            }/v1/admin/mono-sms/reserved`,
            {
                params: data,
            },
        );
        return response.data.result;
    } catch (e) {
        console.log(e);
    }
};
/** 메세지 내역(신)의 count를 가져오는 함수
 * type : send_history(발송 내역) / reserved_history(예약 내역)
 * {
 *  search_start_time
 *  search_end_time
 *  keyword
 *  group_key
 *  job_type (null(전체), SMS, LMS, MMS)
 * }
 */
export const getMonoMessageHistoryCount = async (data, type) => {
    const sendType = type || 'send_history';
    try {
        // kt - 발송 내역
        if (sendType === 'send_history') {
            const response = await axios.get(
                `${
                    Api.ServerJSON.getInstance().BROJ_MESSAGE_API_SERVER
                }/v1/admin/mono-sms/count`,
                {
                    params: data,
                },
            );

            return response.data.result;
        }
        // kt - 예약 내역
        const response = await axios.get(
            `${
                Api.ServerJSON.getInstance().BROJ_MESSAGE_API_SERVER
            }/v1/admin/mono-sms/reserved/count`,
            {
                params: data,
            },
        );
        return response.data.result;
    } catch (e) {
        console.log(e);
    }
};
// 기존 getMessageHistory 함수(구버전, 이 함수에서 무조건 mono(신), 구(nano it)를 동시에 부르도록 되어있음 -> 상단 리팩토링 함수
// export const getMessageHistory = async (data) => {
//     let sms = [];
//     let lms = [];
//     try {
//         let response = await axios.get(
//             `${
//                 Api.ServerJSON.getInstance().BROJ_SMS_NANO_SERVER
//             }massage/sms?sendDate=${data.date}&TR_ETC1=${data.jgroup_key}`,
//         );
//         if (response.data.data) {
//             sms = [...sms, ...response.data.data];
//         }

//         /** mms API를 요청하는 양식이지만, 아직 mms쪽 서버 개발이 안된 상태이며, lms 데이터를 넘기는 형태로 되어있습니다.
//          * 따라서, 나중에 mms가 만들어지면 그때 이걸 그대로 사용하면 됩니다.
//          */
//         response = await axios.get(
//             `${
//                 Api.ServerJSON.getInstance().BROJ_SMS_NANO_SERVER
//             }massage/mms?sendDate=${data.date}&ETC1=${data.jgroup_key}`,
//         );
//         if (response.data.data) {
//             lms = [...lms, ...response.data.data];
//         }

//         response = await axios.get(
//             `${
//                 Api.ServerJSON.getInstance().BROJ_MESSAGE_API_SERVER
//             }/v1/admin/mono-sms`,
//             {
//                 params: data,
//             },
//         );

//         sms = [
//             ...sms,
//             ...response.data.result
//                 .filter((item) => item.job_type === 'SMS')
//                 .map((filtered) => {
//                     filtered.is_reserved = false;
//                     return filtered;
//                 }),
//         ];
//         lms = [
//             ...lms,
//             ...response.data.result
//                 .filter((item) => item.job_type === 'LMS')
//                 .map((filtered) => {
//                     filtered.is_reserved = false;
//                     return filtered;
//                 }),
//         ];

//         response = await axios.get(
//             `${
//                 Api.ServerJSON.getInstance().BROJ_MESSAGE_API_SERVER
//             }/v1/admin/mono-sms/reserved`,
//             {
//                 params: data,
//             },
//         );

//         sms = [
//             ...sms,
//             ...response.data.result
//                 .filter((item) => item.job_type === 'SMS')
//                 .map((filtered) => {
//                     filtered.is_reserved = true;
//                     filtered.submit_time = filtered.schedule_time; // 빠른 개발을 위해... 현재 컴포넌트는 '날짜'하나밖에 없기 때문
//                     return filtered;
//                 }),
//         ];
//         lms = [
//             ...lms,
//             ...response.data.result
//                 .filter((item) => item.job_type === 'LMS')
//                 .map((filtered) => {
//                     filtered.is_reserved = true;
//                     filtered.submit_time = filtered.schedule_time;
//                     return filtered;
//                 }),
//         ];

//         // console.log('response', response);
//         return { sms, lms };
//     } catch (e) {
//         console.log(e);
//     }
// };

// export const getMonoMessageHistory = async (data) => {
//   try {
//     let response = await axios.get(
//       `${Api.ServerJSON.getInstance().BROJ_MESSAGE_API_SERVER}/v1/admin/mono-sms`
//     , {
//       params: data
//     })

//     console.log('response', response);
//   }
//   catch(e) {
//     console.log(e);
//   }
// }

/**
 * deprecated
 */
// export const putSenderNumberAdd = async (data) => {
//     try {
//         const response = await axios.post(
//             `${
//                 Api.ServerJSON.getInstance().BROJ_SMS_NANO_SERVER
//             }massage/certificate`,
//             data,
//         );
//         return response.data;
//     } catch (error) {
//         console.log(error);
//     }
// };

export const putSenderNumberAddToKTServer = async (data) => {
    try {
        const response = await axios.post(
            `${
                Api.ServerJSON.getInstance().BROJ_MESSAGE_API_SERVER
            }/v1/admin/groups/${data.group_key}/certificates`,
            data,
        );
        return response.data;
    } catch (error) {
        console.log(error);
    }
};
/** 푸시 알림 내역을 가져오는 함수
 * {
 *  page_size
 *  page_index
 *  started_dttm
 *  finished_dttm
 *  status
 *  keyword
 *  sort_properties
 *  sort_desc
 *  jgroup_key
 * }
 */
export const getPushNotificationHistory = async (form) => {
    try {
        const response = await axios.post(
            `${
                Api.ServerJSON.getInstance().BROJ_ALARM_SERVER
            }push/api/retrieve/pushmjmember/page`,
            form,
        );
        return response.data.results;
    } catch (e) {
        console.log(e);
    }
};
/** 알림톡 내역을 가져오는 함수
 * type : logs(발송 내역) / reserved(예약 내역)
 * {
 *  page
 *  size
 *  search_start_time
 *  search_end_time
 *  keyword
 *  group_key
 * }
 */
export const getKakaoAlimTalkHistory = async (data, type) => {
    const selectedType = type ? type : 'logs';
    try {
        const response = await axios.get(
            `${
                Api.ServerJSON.getInstance().BROJ_MESSAGE_API_SERVER
            }/v1/admin/alimtalk/${selectedType}`,
            {
                params: data,
            },
        );
        return response.data.result;
    } catch (e) {
        console.log(e);
    }
};
/** 알림톡 count를 가져오는 함수
 * type : logs(발송 내역) / reserved(예약 내역)
 * {
 *  search_start_time
 *  search_end_time
 *  keyword
 *  group_key
 * }
 */
export const getKakaoAlimTalkCount = async (data, type) => {
    const selectedType = type ? type : 'logs';
    try {
        const response = await axios.get(
            `${
                Api.ServerJSON.getInstance().BROJ_MESSAGE_API_SERVER
            }/v1/admin/alimtalk/${selectedType}/count`,
            {
                params: data,
            },
        );
        return response.data.result;
    } catch (e) {
        console.log(e);
        throw e;
    }
};
/** 문자 메세지 내역(신) > 예약 내역 삭제하는 함수
 * {
 *  job_ids (array)
 * }
 */
export const deleteReservedMonoMessage = async (jobIds) => {
    try {
        const response = await axios.delete(
            `${
                Api.ServerJSON.getInstance().BROJ_MESSAGE_API_SERVER
            }/v1/admin/mono-sms`,
            { data: jobIds },
        );
        return response.data.result;
    } catch (e) {
        console.log(e);
        throw e;
    }
};
/* 자동알림 설정 수정하는 api */
export const modifyAutoMessageSettig = async (data) => {
    try {
        const response = await axios.patch(
            `${Api.ServerJSON.getInstance().BROJ_SERVER}api/jgroup/${
                data.jgroup_key
            }/auto-message/${data.auto_message_key}`,
            data.modifyData,
        );
        return response.data.result;
    } catch (e) {
        console.log(e);
        throw e;
    }
};

export const deleteAutoMessageSetting = async (data) => {
    console.log(data);
    try {
        const response = await axios.delete(
            `${Api.ServerJSON.getInstance().BROJ_SERVER}api/jgroup/${
                data.jgroup_key
            }/auto-message/${data.selectedToggleBtn.auto_message_key}`,
        );
        return response.data.result;
    } catch (e) {
        console.log(e);
    }
};

/**자동알림 설정 생성 api */
export const createAutoMessage = async (data) => {
    try {
        const response = await axios.post(
            `${Api.ServerJSON.getInstance().BROJ_SERVER}api/jgroup/${
                data.jgroup_key
            }/auto-message`,
            data.createAutoMessageData,
        );
        return response.data.result;
    } catch (e) {
        console.log(e, e.response);
        throw e;
    }
};

export const patchCallingNumber = async (data) => {
    try {
        const response = await axios.patch(
            `${Api.ServerJSON.getInstance().BROJ_SERVER}api/jgroup/${
                data.jgroup_key
            }/auto-message/default-calling-number/${data.defaultNumber}`,
        );
    } catch (e) {
        console.log(e, e.error);
    }
};
/** KAKAO 승인 받은 템플릿 가져오는 api */
export const getKakaoTemplates = async () => {
    try {
        const response = await axios.get(
            `${
                Api.ServerJSON.getInstance().BROJ_MESSAGE_API_SERVER
            }/v1/admin/kakao-alimtalk-templates`,
        );
        return response.data.templates;
    } catch (e) {
        console.log(e, e.error);
    }
};
